<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <el-form-item>
          <el-input
            v-model="dataForm.keyword"
            :placeholder="kwPlaceHolder"
            class="wd500 input-with-select-lg"
            :class="{ hideInputActive: dataForm.noClientCode || dataForm.noLinkedEngagement }"
            v-regexFilter="halfWidthRegex"
          >
            <el-select v-model="dataForm.kwType" slot="prepend" placeholder="please select" @change="kwTypeChange">
              <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.country" filterable multiple clearable placeholder="Country of Company">
            <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.coordinatorIds" placeholder="select coordinator" multiple clearable>
            <el-option label="Unassigned" :value="-1"></el-option>
            <el-option v-for="item in userList" :key="item.value" :label="item.nickname || item.username" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.checkerIds" placeholder="select checker" multiple clearable>
            <el-option label="Unassigned" :value="-1"></el-option>
            <el-option v-for="item in userList" :key="item.value" :label="item.nickname || item.username" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.auditorIds" placeholder="select reviewer" multiple clearable>
            <el-option label="Unassigned" :value="-1"></el-option>
            <el-option v-for="item in userList" :key="item.value" :label="item.nickname || item.username" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchStartToEndMillisecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start Time"
            end-placeholder="End Time"
            style="width: 384px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select-all
            :optionList="applymentStatusExcludeDraftList"
            placeholder="Status"
            @elSelectAllChange="
              list => {
                dataForm.applymentStatus = list;
              }
            "
          ></el-select-all>
        </el-form-item>
        <el-form-item>
          <el-select v-model="linkedTransaction" multiple clearable placeholder="Linked Transaction">
            <el-option v-for="item in linkedTransactionList" :key="item.title" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.businessGenre" clearable placeholder="Entity Type">
            <el-option v-for="item in entityTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.riskRating" multiple clearable placeholder="Risk Rating">
            <el-option label="Blank" value="null"></el-option>
            <el-option v-for="item in riskRatingTypes" :key="item.title" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
            <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 批量操作 -->
    <div id="operationArea">
      <!-- 批量复核 -->
      <el-button
        v-if="isAuth('company:audit')"
        type="primary"
        plain
        size="small"
        icon="el-icon-thumb"
        @click="handleBatchAudit"
        :disabled="dataListSelections.length <= 0"
        class="mb16"
      >
        Reviewer Finish Approve
      </el-button>
      <!-- 批量退款复核 -->
      <el-button
        v-if="isAuth('company:audit')"
        type="primary"
        plain
        size="small"
        icon="el-icon-thumb"
        @click="handleBatchRefundAudit"
        :disabled="dataListSelections.length <= 0"
        class="mb16"
      >
        Reviewer Refund Approve
      </el-button>
      <!-- 导出 excel -->
      <el-button
        v-if="isAuth('company:audit')"
        type="primary"
        plain
        size="small"
        icon="el-icon-download"
        :loading="batchDownBtnLoading"
        @click="handleExportExcel"
        :disabled="dataListSelections.length <= 0"
        class="mb16"
      >
        Export Excel
      </el-button>
      <!-- 展开/收起全部 -->
      <el-button type="primary" plain size="small" icon="el-icon-arrow-down" @click="expandAllHandle" class="mb16">Expand All</el-button>
      <el-button type="primary" plain size="small" icon="el-icon-arrow-up" @click="collapseAllHandle" class="mb16">Collapse All</el-button>
    </div>
    <!-- 列表 -->
    <div class="tableWrap">
      <el-table
        ref="applymentTable"
        max-height="600"
        :data="dataList"
        v-loading="dataListLoading"
        @selection-change="selectionChangeHandle"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        :row-class-name="getRowClassName"
        style="width: 100%"
      >
        <!-- 展开 -->
        <el-table-column type="expand" width="30px" fixed="left">
          <template slot-scope="props">
            <Expand :adjustmentList="props.row.adjustmentList || []" />
          </template>
        </el-table-column>

        <el-table-column type="selection" align="center" width="40" fixed="left"></el-table-column>
        <el-table-column prop="applymentNo" align="center" label="Transaction No." fixed="left" width="140" />
        <el-table-column align="center" label="Supplier" width="200" fixed="left">
          <template slot-scope="scope">
            <p>{{ supplierAbbrDeduplicateFormat(scope.row.supplierList) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="Create Time" width="130" sortable="custom" />
        <el-table-column prop="commitTime" align="center" label="Submit Time" width="140" sortable="custom" />
        <el-table-column prop="terminatedTime" align="center" label="Terminated Time" width="170" sortable="custom" />
        <el-table-column align="center" label="Client Code" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.acraCompanyInfoList?.length > 0">{{ clientCodeDeduplicateFormat(scope.row.acraCompanyInfoList) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="riskAssessmentData.rating" align="center" label="Risk Rating" width="102">
          <template slot-scope="scope">
            <p v-if="scope.row.riskAssessmentData">{{ riskRatingFormat(scope.row.riskAssessmentData.rating) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="applymentStatus" align="center" label="Status" width="200">
          <template slot-scope="scope">
            <p>{{ applymentStatusFormat(scope.row.applymentStatus) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Linked Transaction" width="160" :formatter="linkedTransactionFormat" />
        <el-table-column align="center" label="Linked Engagement ID" width="184">
          <template slot-scope="scope">
            <span v-if="scope.row.engagementList?.length > 0">{{ engagementIdDeduplicateFormat(scope.row.engagementList) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="businessGenre" align="center" label="Entity Type" width="160">
          <template slot-scope="scope">
            <p>{{ entityTypeFormat(scope.row.businessGenre) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="applicantName" align="center" label="Applicant Name" width="140" />
        <el-table-column prop="applicantEmail" align="center" label="Applicant Email" width="180" />
        <el-table-column prop="country" align="center" label="Country of Company" width="180" />
        <el-table-column align="center" label="Entity Name" width="360">
          <template slot-scope="scope">
            <div v-for="(name, index) in proposedCompanyNameFormat(scope.row)" :key="`entityName-${scope.row.id}-${index}`">
              {{ name }}
            </div>
            <div v-if="scope.row.fundInfoList?.length > 0">
              {{ scope.row.fundInfoList.map(item => item.fundName)?.join(", ") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Billing Party" width="280">
          <template slot-scope="scope">
            <span v-if="scope.row.orderInfoList?.length > 0">
              {{ billingPartyDeduplicateFormat(scope.row.orderInfoList) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="coordinator" align="center" label="Coordinator" width="180" :formatter="operatorStaffFormat" />
        <el-table-column prop="checker" align="center" label="Checker" width="180" :formatter="operatorStaffFormat" />
        <el-table-column prop="auditor" align="center" label="Reviewer" width="180" :formatter="operatorStaffFormat" />
        <el-table-column align="center" label="Action" fixed="right" width="110">
          <template slot-scope="scope">
            <el-button @click="detailHandler(scope.row.id)" type="text" class="fwb">Detail</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
    <!-- 批量复核 - 弹框 -->
    <batch-audit ref="batchAuditModal" @refreshDataList="getDataList"></batch-audit>
  </div>
</template>
<script>
import { downloadFile } from "@/utils";
import Expand from "./components/Expand";
import BatchAudit from "./modal/BatchAudit.vue";
import ElSelectAll from "@/components/ElSelectAll";
import Pagination from "@/components/Pagination";
import searchMixin from "@/mixins/searchMixin";
import tableMixin from "@/mixins/tableMixin";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, paginationMixin, tableMixin, formatterMixin],
  components: {
    Expand,
    BatchAudit,
    ElSelectAll,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      kwTypes: [
        {
          title: "Transaction No.",
          value: "applymentNo",
          placeholder: "Transaction No.",
        },
        {
          title: "Applicant",
          value: "applicant",
          placeholder: "Applicant Name Or Applicant Email",
        },
        {
          title: "Entity Name",
          value: "companyName",
          placeholder: "Entity Name",
        },
        {
          title: "Billing Party",
          value: "billingParty",
          placeholder: "Billing Party",
        },
        {
          title: "Client Code",
          value: "clientCode",
          placeholder: "Client Code",
        },
        {
          title: "Client Code Blank",
          value: "clientCodeBlank",
          placeholder: "",
        },
        {
          title: "Linked Engagement ID Blank",
          value: "linkedEngagementIdBlank",
          placeholder: "",
        },
      ],
      watchStartToEndMillisecondTimeRange: null,
      linkedTransactionList: [
        { title: "Renewal", value: 1 },
        { title: "Supplemental", value: 2 },
        { title: "Be Renewed", value: 3 },
        { title: "Have Supplements", value: 4 },
      ],
      linkedTransaction: [],
      dataForm: {
        kwType: "applymentNo",
        keyword: "",
        applymentNo: "",
        applicant: "",
        companyName: "",
        fundsName: "",
        coordinatorIds: "",
        checkerIds: "",
        auditorIds: "",
        startTime: null,
        endTime: null,
        applymentStatus: "",
        businessGenre: "",
        supplierId: "",
        noClientCode: null,
        noLinkedEngagement: null,
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      userList: [],
      supplierList: [],
      batchDownBtnLoading: false, // 批量导出
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "entityTypes", "riskRatingTypes"]),
  },
  methods: {
    // 判断表格行是否可以展开
    getRowClassName({ row }) {
      const list = row.adjustmentList;
      if (!list || list.length === 0) {
        return "hide-expand";
      }
      return "";
    },
    // 展开全部(仅展开有 adjustmentList 的行, 与 hide-expand 隐藏箭头的行为保持一致)
    expandAllHandle() {
      this.dataList
        .filter(row => row.adjustmentList?.length)
        .forEach(row => {
          this.$refs.applymentTable.toggleRowExpansion(row, true);
        });
    },
    // 收起全部
    collapseAllHandle() {
      this.dataList.forEach(row => {
        this.$refs.applymentTable.toggleRowExpansion(row, false);
      });
    },
    // kwType下拉框 - change
    kwTypeChange() {
      if (this.dataForm.kwType == "clientCodeBlank") {
        this.dataForm.keyword = "";
        this.dataForm.noClientCode = true;
      } else {
        this.dataForm.noClientCode = null;
      }
      if (this.dataForm.kwType == "linkedEngagementIdBlank") {
        this.dataForm.keyword = "";
        this.dataForm.noLinkedEngagement = true;
      } else {
        this.dataForm.noLinkedEngagement = null;
      }
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    //用户列表
    async getSysUserList() {
      const { data } = await this.$http.get(`/admin/sysUser/getList`);
      this.userList = data;
    },
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    //申请单状态
    handleApplymentStatusChange() {
      this.getDataList(1);
    },
    handleCountryChange() {
      this.getDataList(1);
    },
    //详情
    detailHandler(id) {
      this.$router.push(`/companyApplyment/${id}`);
    },
    // 导出 Excel
    handleExportExcel() {
      const ids = this.dataListSelections.map(item => item.id);
      this.batchDownBtnLoading = true;
      this.$http
        .get("/admin/companyApplymentManage/export", {
          params: { ids },
          responseType: "blob",
        })
        .then(res => {
          downloadFile(res);
        })
        .finally(() => {
          this.batchDownBtnLoading = false;
        });
    },
    // 批量复核
    handleBatchAudit() {
      let applymentIds = [];
      if (this.dataListSelections.length != 0) {
        this.dataListSelections.forEach(item => {
          if (item.applymentStatus == "AUDITING") {
            applymentIds.push(item.id);
          }
        });
        if (applymentIds.length == 0) {
          this.$message.warning("You can't operate it until the filter of Applyment Status is 'Reviewing'.");
          return false;
        }
      } else {
        this.$message.warning("You are not selected yet");
        return false;
      }
      this.$refs.batchAuditModal.init(applymentIds, "Finish");
    },
    // 批量退款复核
    handleBatchRefundAudit() {
      let applymentIds = [];
      if (this.dataListSelections.length != 0) {
        this.dataListSelections.forEach(item => {
          if (item.applymentStatus === "REFUND_APPLY_AGREED") {
            applymentIds.push(item.id);
          }
        });
        if (applymentIds.length == 0) {
          this.$message.warning("You can't operate it until the filter of Applyment Status is 'Refund Checking Passed'.");
          return false;
        }
      } else {
        this.$message.warning("You are not selected yet");
        return false;
      }
      this.$refs.batchAuditModal.init(applymentIds, "Refund");
    },
    // 获取数据列表
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }

      let linkedTransaction = {};
      if (this.linkedTransaction.includes(1)) linkedTransaction.isRenew = true;
      if (this.linkedTransaction.includes(2)) linkedTransaction.isLaterService = true;
      if (this.linkedTransaction.includes(3)) linkedTransaction.hasRenew = true;
      if (this.linkedTransaction.includes(4)) linkedTransaction.hasLaterService = true;

      const { code, data } = await this.$http.get("/admin/companyApplymentManage/paging", {
        params: {
          current: this.current,
          size: this.pageSize,
          // "orders[0].asc": false,
          // "orders[0].column": "id",
          ...this.dataForm,
          ...linkedTransaction,
          sourceFlag: 1,
          [this.dataForm.kwType]: this.dataForm.keyword,
        },
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
  },
  activated() {
    this.getSysUserList();
    this.getSupplierList();
    this.getDataList();
  },
};
</script>

<style lang="scss" scoped>
.company-name-tag {
  display: inline-flex;
  flex-direction: column;
}

.hideInputActive {
  width: 200px !important;
  border-right: 1px solid #dcdfe6;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;

  ::v-deep .el-input-group__prepend + .el-input__inner {
    display: none;
  }
}

.page-container {
  ::v-deep {
    .el-table {
      .el-table__expand-icon {
        margin-top: 4px !important;
      }
    }
  }
}

.tableWrap {
  ::v-deep {
    .hide-expand {
      .el-table__expand-column {
        pointer-events: none;
        .el-table__expand-icon {
          display: none;
        }
      }
    }
  }
}
</style>
